import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { FiMoreHorizontal } from "react-icons/fi";
import { Dropdown } from "react-bootstrap";
import CompanySubscriptionsEditModal from "components/Companies/CompanySubscriptionsEditModal";
import ChangeOwnerEmailModal from "components/Companies/ChangeOwnerEmailModal";
import ChangeCompanyNameModal from "components/Companies/ChangeCompanyNameModal";
import { showModal, hideModal } from "actions/modalActions";
import * as companyActions from "actions/companyActions";
import DataTable from "components/DataTable/DataTable";
import Moment from "react-moment";

class CompanyPartnersList extends Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openEditSubscriptionsModal =
			this.openEditSubscriptionsModal.bind(this);
		// this.openDeleteCompanyModal =
		// 	this.openDeleteCompanyModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	closeModal() {
		this.props.hideModal();
	}

	openEditSubscriptionsModal(partner_company) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("subscriptionsPage.manageSubscription"),
				style: { width: "670px" },
				content: (
					<CompanySubscriptionsEditModal
						partner_company={partner_company}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openChangeCompanyNameModal(partner_company) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("subscriptionsPage.changeCompanyName"),
				style: { width: "450px" },
				content: (
					<ChangeCompanyNameModal
						partner_company={partner_company}
						handleClose={this.closeModal}
						onSuccess={this.props.onCompanyUpdated}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openChangeOwnerEmailModal(partner_company) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("subscriptionsPage.changeEmail"),
				style: { width: "450px" },
				content: (
					<ChangeOwnerEmailModal
						partner_company={partner_company}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// openDeleteCompanyModal(idCompany) {
	// 	this.props.showModal(
	// 		{
	// 			open: true,
	// 			title: "Eliminar empresa",
	// 			style: { width: "400px" },
	// 			message:
	// 				"¿Desea eliminar la empresa? Esta acción no se puede deshacer",
	// 			deleteAction: () => this.confirmDelete(idCompany),
	// 			closeModal: this.closeModal,
	// 		},
	// 		"delete"
	// 	);
	// }

	openAlertModal(title, message) {
		this.props.showModal(
			{
				open: true,
				title: title,
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	// confirmDelete = async (idCompany) => {
	// 	const response = await companyService.remove(idCompany);

	// 	if (!response.ok) {
	// 		let textError = errorFormating(response);
	// 		this.openAlertModal("Error al eliminar", textError.id);
	// 	} else {
	// 		//this.props.getAll_();
	// 		this.closeModal();
	// 	}
	// };

	getColumns = () => {
		const { t } = this.props;
		return [
			{
				key: "name",
				header: t("common.name"),
				render: (partner_company) => (
					<button
						className="btn-transparent btn-editable"
						onClick={() => this.openEditSubscriptionsModal(partner_company)}
					>
						{partner_company.name}
					</button>
				),
			},
			{
				key: "code",
				header: t("subscriptionsPage.table.code"),
				render: (partner_company) => partner_company.code || "—",
			},
			{
				key: "active_users",
				header: t("subscriptionsPage.table.activeEmployees"),
				render: (partner_company) =>
					partner_company.active_users != null
						? partner_company.active_users
						: "—",
			},
			{
				key: "subscription_type",
				header: t("subscriptionsPage.table.plan"),
				render: (partner_company) => partner_company.subscription_type || "—",
			},
			{
				key: "created",
				header: t("subscriptionsPage.table.created"),
				render: (partner_company) =>
					partner_company.created ? (
						<Moment format="DD/MM/YYYY HH:mm">{partner_company.created}</Moment>
					) : (
						"—"
					),
			},
		];
	};

	render() {
		const { t } = this.props;
		return (
			<DataTable
				tableClassName="table-subscriptions table-hover"
				columns={this.getColumns()}
				rows={this.props.partner_companies}
				rowKey={(row) => row.id}
				emptyMessage={t("common.noResults")}
				actionsColumn={{
					render: (partner_company) => (
						<Dropdown>
							<Dropdown.Toggle variant="action">
								<FiMoreHorizontal />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item
									as="button"
									onClick={() =>
										this.openEditSubscriptionsModal(partner_company)
									}
								>
									{t("subscriptionsPage.manageSubscription")}
								</Dropdown.Item>
								<Dropdown.Item
									as="button"
									onClick={() =>
										this.openChangeCompanyNameModal(partner_company)
									}
								>
									{t("subscriptionsPage.changeCompanyName")}
								</Dropdown.Item>
								<Dropdown.Item
									as="button"
									onClick={() =>
										this.openChangeOwnerEmailModal(partner_company)
									}
								>
									{t("subscriptionsPage.changeOwnerEmail")}
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					),
					className: "td-actions",
				}}
			/>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.companyReducer;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllSubscriptions: (q) => dispatch(companyActions.getAllSubscriptions(q)),
});

export default withTranslation()(connect(
	mapStateToProps,
	mapDispatchToProps
)(CompanyPartnersList));
